import managementRoute from "./manage";
import memberRoute from "./client";
import newAdminEdicRoute from "./new-admin";

export default [...memberRoute, ...managementRoute, ...newAdminEdicRoute];
